import { AsapQueue } from './1b1a0677ebf3f65eb3a9e0d4002b859c09b6a622d1762d1c8dd3e064c8d50ef2.cfe-internal.js';
import { TaskFactory } from './582da755260a886b306c0c1bf60e338751f280d0b194077bfe6c6e7af4159c8a.cfe-internal.js';

var asapQueue = new AsapQueue();
var taskFactory = new TaskFactory(asapQueue.registerPendingError);
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
function asap(task) {
  asapQueue.enqueueTask(taskFactory.create(task));
}

export { asap };
